import React from 'react';
import PromotionBanner from '@Header/Banners/PromotionBanner/PromotionBannerFactory';
import { getPromotionsWithBanner, selectUserProfile } from '@Header/ducks/selectors';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const component = ({ promotions, environment, userId }) => {
  return (
    <>
      {promotions.map(promotion => {
        switch (promotion.name) {
          case 'covid19-banner':
            return null;
          default:
            return (
              <PromotionBanner
                key={promotion.name}
                content={promotion.banner.content}
                experiment={promotion.experiment}
                environment={environment}
                userId={userId}
              />
            );
        }
      })}
    </>
  );
};

component.propTypes = {
  promotions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.any,
    banner: PropTypes.shape({
      content: PropTypes.any
    }),
    experiment: PropTypes.any
  })),
  environment: PropTypes.string,
  userId: PropTypes.string
};

const mapStateToProps = state => ({
  promotions: getPromotionsWithBanner(state),
  userId: selectUserProfile(state)?.userId
});

export default connect(mapStateToProps)(component);
